import { TrustSummaryData } from '@/modules/trusts/TrustDetails/TrustDetails.types';

import { EntityDetailsData } from '../entityDetails.types';
import {
  getGrantorNameFromFragment,
  getGrantorNamesShort,
  getSharedSummaryProperties,
} from './trustCardUtils';

export function getRevocableIrrevocableTrustSummaryProperties({
  entity,
}: EntityDetailsData): TrustSummaryData {
  if (
    entity.subtype.__typename !== 'IrrevocableTrust' &&
    entity.subtype.__typename !== 'RevocableTrust'
  ) {
    throw new Error('Invalid trust type');
  }

  return {
    ...getSharedSummaryProperties(entity),
    grantorNames:
      entity.subtype.grantors?.map(getGrantorNameFromFragment) || [],
    grantorNamesShort: getGrantorNamesShort(entity.subtype.grantors),
    effectiveDate: entity.subtype.effectiveDate ?? undefined,
    beneficiariesGroups: [
      {
        heading: 'Current beneficiaries',
        items: entity.subtype.beneficiaries || [],
        noItemsText: 'No beneficiaries',
      },
    ],
    trustDetailsItems: [],
  };
}
